// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0d64df8","455":"a55596b7"}[chunkId] + ".chunk.js";
};